import React, { Component } from "react";
import {
  mode,
  profile,
  alert,
  float,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  loading,
  Status,
  params,
  DateRangePicker,
  Select,
  Swal,
  Pagination,
  Navbar,
  Modal,
  XLSX,
  saveAs,
  StatusTnx,
  linkRole,
  CopyCell,
  maskAccount,
} from "../../components/CustomComponent.js";

import Dropdown from "react-bootstrap/Dropdown";
import { NumericFormat } from "react-number-format";
import "bootstrap/dist/css/bootstrap.min.css";
export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_refund: false,
      modal_detail: false,

      // SEARCH
      filter_start_date: "",
      filter_end_date: "",
      filter_data_search: "",
      filter_currency: "THB",

      // EXPORT
      export_date: "",

      // LIST
      data: [],
      count: 10,
      loaded: false,

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      broker: null,
      customer: null,

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      mismatch_bank_account_number: "",

      refund_amount: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_data_search,
      filter_start_date,
      filter_end_date,
      filter_currency,
    } = this.state;
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET(`profits/list-mismatch`, {
        page_size: 10,
        page: page,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: "mismatch",
        currency: filter_currency,
      }), 
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    } 
    this.setState({
      data,
      count,
      loaded: true,
    });
    loading(false);
  };
  Update = async () => {
    const { fee_type, fee_rate, is_vat, status, is_usdt } = this.state;
    if (!fee_type.trim()) {
      alert("", "warning", "Warning", "Please select Fee Rate Type");
      return;
    } else if (!fee_rate.trim()) {
      alert("", "warning", "Warning", "Please input Fee Rate");
      return;
    }
    if (["cancel", "success"].includes(status)) {
      Swal.fire({
        title: "Confirm",
        text: `Do you want to ${
          status === "cancel" ? "Reject" : "Approve"
        } the transaction?`,
        icon: "info",
        input: "textarea",
        inputPlaceholder: "Enter remark...",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
        color: mode === "dark" ? "#fff" : "#000000", // Text color
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
      }).then(async (re) => {
        if (re.isConfirmed) {
          const remark = re.value;
          loading(true);
          let body = {
            fee_type,
            fee_rate: Number(fee_rate).toFixed(4),
            is_vat,
            status,
            is_usdt,
            remark,
          };

          let result = await PUT(
            `transactions/deposits/update/` + this.state.uid,
            body
          );
          if (result?.status) {
            alert("#", "success");
          } else {
            alert(
              "",
              "warning",
              "Warning",
              result?.message || "An error occurred. Please try again."
            );
          }
          loading(false);
        }
      });
    } else {
      if (
        await alert(
          "",
          "info",
          "Confirm",
          "Do you want to confirm the submission?",
          "Confirm",
          "Cancel"
        )
      ) {
        loading(true);
        let body = {
          fee_type,
          fee_rate: Number(fee_rate).toFixed(4),
          is_vat,
          status,
          is_usdt,
        };

        let result = await PUT(
          `transactions/deposits/update/` + this.state.uid,
          body
        );
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again."
          );
        }
        loading(false);
      }
    }
  };
  Refund = async () => {
    const { refund_amount, uid } = this.state;
    if (!refund_amount) {
      alert("", "warning", "Warning", "Please input Refund Amount");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to refund this transaction?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        uid,
        amount: Number(refund_amount),
      };

      let result = await POST(`transactions/withdrawals/refund`, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  ExportCSV = async () => {
        const {
          filter_data_search,
          filter_start_date,
          filter_end_date,
        } = this.state;
        loading(true);
        let result = await GET(`profits/list-mismatch`, {
           page_size: 1000000,
        page: 0,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: "mismatch",
        currency: "",
        });
        if (result?.status) {
          const data_transaction = result.data;
    
          // EXPORT CSV
          const json_data = data_transaction.map((item) => ({
            time: format_date(item.created_at, "dd/mm/yy hh:mm", "en"),
            "Ref No": item.ref_no,
            RefQR: item.reference_id,
            Broker: item.broker?.name_en || "-",
            Customer: item.customer?.name_en || "-",
            Amount: toFixed(item.amount, 2),
            Fee: toFixed(item.fee, 2),
            "VAT Type": item.is_vat ? "VAT" : "NO VAT",
            VAT: item.is_vat ? toFixed(item.vat, 2) : "-",
            "Amount Net": toFixed(item.amount_net, 2),
            Process:
              item.process_type === "manual"
                ? "Manual"
                : item.process_type === "auto"
                  ? "Auto"
                  : "-",
            Status: item.ref_no_refund ? "refund" : (item.status || "-"),
            Remark: item.remark,
            currency: item.currency,
          }));
          // 1. Convert JSON to worksheet
          const worksheet_thb = XLSX.utils.json_to_sheet(
            json_data.filter((e) => e.currency === "THB"),
          );
          const worksheet_lak = XLSX.utils.json_to_sheet(
            json_data.filter((e) => e.currency === "LAK"),
          );
    
          // 2. Create a new workbook and append the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet_thb, "THB");
          XLSX.utils.book_append_sheet(workbook, worksheet_lak, "LAK");
    
          // 3. Write the workbook to binary buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
    
          // 4. Save to file
          const data = new Blob([excelBuffer], {
            type: "application/octet-stream",
          });
          saveAs(
            data,
            `mismatch-${format_date(
              filter_start_date,
              "dd/mm/yy",
              "en",
            )}-${format_date(filter_end_date, "dd/mm/yy", "en")}.xlsx`,
          );
        }
        loading(false);
      };
  render() {
    const {
      modal_refund,
      modal_detail,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_currency,
      export_date,
      data,
      count,
      loaded,
      type,
      ref_no,
      status,
      amount,
      created_at,
      fee,
      fee_rate,
      fee_type,
      vat,
      is_vat,
      amount_net,
      remark,
      broker,
      customer,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      mismatch_bank_account_number,
      mismatch_bank_code,
      mismatch_bank_account_name_en,
      mismatch_bank_account_name_th,

      refund_amount,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Broker</div>
                <h2 className="ar-title mb-1">Mismatch Reports</h2>
                <div className="ar-subtitle">
                  Identify and resolve transaction discrepancies
                </div>
              </div>
              <div className="ar-hero-actions">
              <button
                className="ar-btn-ghost mismatchs.read"
                onClick={async () => {
                  this.ExportCSV()
                }}
              >
                <span className="icon me-2">{"\uf019"}</span>Export CSV
              </button>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
                <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Refno..."
                  onChange={(e) => {
                    this.setState({ filter_data_search: e.target.value });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") this.Get(1);
                  }}
                  value={filter_data_search}
                />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Date Range</span>
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({
                        filter_start_date: e.start_date,
                        filter_end_date: e.end_date,
                      });
                    }}
                    value={{
                      start_date: filter_start_date,
                      end_date: filter_end_date,
                    }}
                    max={filter_end_date}
                  />
                </div>
                <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_start_date: "",
                        filter_end_date: "",
                        filter_data_search: "",
                        filter_currency: "THB",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
                </div>
              </div>
              <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf071"}</span>
                  Mismatch
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
              </div>
            </div>
            <div className="table-responsive" style={{ minHeight: 300 }}>
              <table className="table table-hover text-nowrap ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap">Time</td>
                    <td className="text-nowrap">Ref No</td>
                    <td className="text-nowrap">RefQR</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">Bank</td>
                    <td className="text-nowrap text-end">Amount</td>
                    <td className="text-nowrap text-end">Fee</td>
                    <td className="text-nowrap text-end">VAT</td>
                    <td className="text-nowrap text-end">Amount Net</td>
                    <td className="text-nowrap text-center">Process</td>
                    <td className="text-nowrap text-center">Status</td>
                    <td
                      className="mismatchs.update text-nowrap text-center td-actions"
                    >
                      Actions
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label="time" className="text-nowrap">
                        {format_date(item.created_at, "dd/mm/yy hh:mm:ss", "en")}
                      </td>
                      <td data-label="Ref No" className="text-nowrap py-1">
                        <div>
                          {/* the fixed height only makes room for the refund line
                              below, so without it let the value center itself */}
                          <div
                            style={
                              item.ref_no_refund ? { height: 14 } : undefined
                            }
                          >
                            <CopyCell value={item.ref_no} />
                          </div>
                          {item.ref_no_refund && (
                            <div>
                              <small className="text-secondary">
                                refund no: {item.ref_no_refund}
                                <span
                                  className="icon ms-1 text-primary pointer"
                                  onClick={() => {
                                    window.location.href = `/${linkRole(profile?.user_type)}/deposits-withdrawals?type=withdrawals&ref_no=${
                                      item.ref_no_refund
                                    }`;
                                  }}
                                >
                                  {"\uf0c1"}
                                </span>
                              </small>
                            </div>
                          )}
                        </div>
                      </td>
                      <td data-label="RefQR" className="text-nowrap py-1">
                        <CopyCell
                          value={item.qrs?.reference_id || item.reference_id}
                        />
                      </td>
                      <td data-label="Customer" className="text-nowrap py-1">
                        {item.customer?.name_en ||
                          item.customer?.name_th ||
                          "-"}
                      </td>
                      <td
                        data-label="Bank"
                        className="text-nowrap py-1"
                      >
                        {item.bank_code &&
                        global.bank.find((e) => e.value === item.bank_code) ? (
                          <div className="d-flex">
                            <img
                              alt="bank"
                              src={require(`../../assets/images/bank/${
                                global.bank.find(
                                  (b) => b.value === item.bank_code
                                )?.icon || "bank.png"
                              }`)}
                              width={18}
                              height={18}
                              style={{ marginRight: 6 }}
                              className="me-2 mt-1"
                            />
                            <div>
                              <div style={{ height: 14 }}>{item.bank_code}</div>
                              <small className="text-secondary">
                                {maskAccount(item.bank_account_number) || "-"}
                              </small>
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td
                        data-label="Amount"
                        className="text-nowrap text-end"
                      >
                        <div className="pu-amount">{toFixed(item.amount, 2)}</div>
                      </td>
                      <td data-label="Fee" className="text-nowrap text-end">
                        {toFixed(item.fee, 2)}
                      </td>
                      <td data-label="VAT" className="text-nowrap text-end">
                        {item.is_vat ? toFixed(item.vat, 2) : "0.00"}
                      </td>
                      <td
                        data-label="Amount Net"
                        className="text-nowrap text-end"
                      >
                        <div className="pu-amount pu-amount-gold">{toFixed(item.amount_net, 2)}</div>
                      </td>
                      <td
                        data-label="Process"
                        className="text-nowrap text-center py-1"
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          {item.process_type === "manual"
                            ? Status("manual", "info")
                            : item.process_type === "auto"
                            ? Status("auto", "success")
                            : Status("-", "warning")}
                        </div>
                      </td>
                      <td
                        data-label="Status"
                        className="text-nowrap text-center py-1"
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          {StatusTnx(item.status)}
                        </div>
                        {item.ref_no_refund && (
                          <div className="d-flex align-items-center justify-content-center mt-1">
                            {Status("refund", "info")}
                          </div>
                        )}
                      </td>
                      <td
                        data-label="Actions"
                        className="mismatchs.update text-center td-actions"
                      >
                        <Dropdown align="end">
                          <Dropdown.Toggle className="pu-action-toggle" id={`mismatch-actions-${index}`}>Action</Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item className="pu-action-item" onClick={() => { this.setState({ ...item, modal_detail: true}); }}>
                              <div className="icon">{"\uf06e"}</div> Detail
                            </Dropdown.Item>
                            <div className="pu-action-sep" />
                            {item.status === "mismatch" && (
                              <Dropdown.Item className={`mismatchs.update pu-action-item`} onClick={() => { this.setState({ ...item, status: "success" },() => {this.Update();}); }}>
                                <div className="icon">{"\uf164"}</div> Approve
                              </Dropdown.Item>
                            )}
                            {item.status === "mismatch" && !item.ref_no_refund && (
                              <Dropdown.Item className={`mismatchs.update pu-action-item danger`} onClick={() => { this.setState({ ...item, refund_amount: "", modal_refund: true }); }}>
                                <div className="icon">{"\uf53a"}</div> Refund
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={12}
                        className="text-center py-5"
                      >
                        <div className="ar-empty">No data</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_detail}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_detail: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Mismatch detail</div>
              <h5 className="fw-bold mb-0">Detail Transaction</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-kv">
              <span className="pu-kv-label">Status</span>
              <span className="pu-kv-value">{StatusTnx(status)}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Ref No.</span>
              <span className="pu-kv-value">{ref_no}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Time</span>
              <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy", "en")}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Type</span>
              <span className="pu-kv-value">{type}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Customer</span>
              <span className="pu-kv-value">{customer?.name_en || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Broker</span>
              <span className="pu-kv-value">{broker?.name_en || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee Rate Type</span>
              <span className="pu-kv-value">{fee_type}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee Rate</span>
              <span className="pu-kv-value">{toFixed(fee_rate, 2)} {fee_type === "percentage" ? "%" : "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Amount</span>
              <span className="pu-kv-value">{toFixed(amount, 2)} THB</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee</span>
              <span className="pu-kv-value">{toFixed(fee, 2)} THB</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">VAT Type</span>
              <span className="pu-kv-value">{is_vat ? "VAT" : "NO VAT"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">VAT</span>
              <span className="pu-kv-value">{toFixed(vat, 2)} THB</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Amount Net</span>
              <span className="pu-kv-value">{toFixed(amount_net, 2)} THB</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Remark</span>
              <span className="pu-kv-value">{remark}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Accountant Remark</span>
              <span className="pu-kv-value">{""}</span>
            </div>
            <div className="pu-section-title mt-3">
              <span className="icon">{"\uf19c"}</span>Bank Account
            </div>

            <div className="pu-kv">
              <span className="pu-kv-label">Bank Name</span>
              <span className="pu-kv-value text-success"><img
                  alt="bank"
                  src={require(`../../assets/images/bank/${
                    global.bank.find((b) => b.value === bank_code)?.icon ||
                    "bank.png"
                  }`)}
                  width={18}
                  height={18}
                  style={{ marginRight: 6 }}
                />
                {bank_code}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Account Number</span>
              <span className="pu-kv-value text-success">{maskAccount(bank_account_number)}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Account Name EN</span>
              <span className="pu-kv-value text-success">{bank_account_name_en}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Account Name TH</span>
              <span className="pu-kv-value text-success">{bank_account_name_th}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Mismatch Bank Name</span>
              <span className="pu-kv-value text-danger"><img
                  alt="bank"
                  src={require(`../../assets/images/bank/${
                    global.bank.find((b) =>
                      JSON.stringify(b).includes(mismatch_bank_code)
                    )?.icon || "bank.png"
                  }`)}
                  width={18}
                  height={18}
                  style={{ marginRight: 6 }}
                />
                {global.bank.find((b) =>
                  JSON.stringify(b).includes(mismatch_bank_code)
                )?.value || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Mismatch Account Number</span>
              <span className="pu-kv-value text-danger">{maskAccount(mismatch_bank_account_number) || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Mismatch Account Name EN</span>
              <span className="pu-kv-value text-danger">{mismatch_bank_account_name_en || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Mismatch Account Name TH</span>
              <span className="pu-kv-value text-danger">{mismatch_bank_account_name_th || "-"}</span>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-outline-dark px-5 rounded-pill"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modal_refund}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_refund: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Refund</div>
              <h5 className="fw-bold mb-0">Refund Order</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="wpx-150 mt-2 pr-label">Refno</div>
              <b>{ref_no}</b>
            </div>
            <div className="d-flex justify-content-between mb-3">
              <div className="wpx-150 mt-2 pr-label">Bank</div>
              <div className="d-flex align-items-center">
                <img
                  alt="bank"
                  src={require(`../../assets/images/bank/${
                    global.bank.find(
                      (b) =>
                        b.value === mismatch_bank_code ||
                        b.code === mismatch_bank_code
                    )?.icon || "bank.png"
                  }`)}
                  width={18}
                  height={18}
                  style={{ marginRight: 6 }}
                />
                <b>
                  {
                    global.bank.find(
                      (b) =>
                        b.value === mismatch_bank_code ||
                        b.code === mismatch_bank_code
                    )?.label
                  }
                </b>
              </div>
            </div>
            <div className="d-flex justify-content-between mb-3">
              <div className="wpx-150 mt-2 pr-label">Account Number</div>
              <b>{maskAccount(mismatch_bank_account_number)}</b>
            </div>
            <div className="d-flex justify-content-between mb-3">
              <div className="wpx-150 mt-2 pr-label">Account Name TH</div>
              <b>{mismatch_bank_account_name_th}</b>
            </div>
            <div className="d-flex justify-content-between mb-3">
              <div className="wpx-150 mt-2 pr-label">Account Name EN</div>
              <b>{mismatch_bank_account_name_en}</b>
            </div>
            <div className="d-flex justify-content-between mb-3">
              <div className="wpx-150 mt-2 pr-label">Amount</div>
              <b>
                {toFixed(amount)} {filter_currency}
              </b>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Refund Amount</div>
              <NumericFormat
                thousandSeparator=","
                decimalScale={2}
                type="text"
                className="form-control pr-input text-end"
                placeholder="Amount..."
                value={refund_amount}
                isAllowed={(values) => {
                  const { floatValue } = values;
                  if (floatValue === undefined) return true;
                  return floatValue <= Number(amount);
                }}
                onValueChange={(values) => {
                  this.setState({ refund_amount: values.value });
                }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.Refund();
              }}
            >
              refund
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_refund: false });
              }}
            >
              cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
